export const material = [
    {
        MATERIAL_CODE: "UTA-BOA-OVA18",
        ITEM: "PLYWOOD 18MM OVL A",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-OVA15",
        ITEM: "PLYWOOD 15MM OVL A",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-OVA12",
        ITEM: "PLYWOOD 12MM OVL A",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-OVA9",
        ITEM: "PLYWOOD 9MM OVL A",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-OVA6",
        ITEM: "PLYWOOD 6MM OVL A",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-OVA3",
        ITEM: "PLYWOOD 3MM OVL A",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-OVB18",
        ITEM: "PLYWOOD 18MM OVL B",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-OVB15",
        ITEM: "PLYWOOD 15MM OVL B",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-OVB12",
        ITEM: "PLYWOOD 12MM OVL B",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-OVB9",
        ITEM: "PLYWOOD 9MM OVL B",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-OVB6",
        ITEM: "PLYWOOD 6 MM OVL B ",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-OVB3",
        ITEM: "PLYWOOD 3 MM OVL B ",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-GRE18",
        ITEM: "PLYWOOD 18MM GRESIK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-BCC18",
        ITEM: "PLYWOOD 18MM BBCC",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-BCC15",
        ITEM: "PLYWOOD 15MM BBCC",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-BCC12",
        ITEM: "PLYWOOD 12MM BBCC",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-BCC9",
        ITEM: "PLYWOOD 9MM BBCC",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-BCC6",
        ITEM: "PLYWOOD 6MM BBCC",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-BCC3",
        ITEM: "PLYWOOD 3MM BBCC",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-ME9MM",
        ITEM: "PLYWOOD 9MM MERANTI",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-ME4MM",
        ITEM: "PLYWOOD 4MM MERANTI",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-ALB18",
        ITEM: "PLYWOOD 18MM ALBA EXP",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-ALB15",
        ITEM: "PLYWOOD 15MM ALBA EXP",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-ALBA9",
        ITEM: "PLYWOOD 9MM ALBA EXP",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-HAN18",
        ITEM: "PLYWOOD 18MM HANA",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "65"
    },
    {
        MATERIAL_CODE: "UTA-BOA-UTY18",
        ITEM: "FLATFORM UTY 18MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-HAN15",
        ITEM: "PLYWOOD 15MM HANA",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "80"
    },
    {
        MATERIAL_CODE: "UTA-BOA-HAN3",
        ITEM: "PLYWOOD 3MM HANA",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-SMA18",
        ITEM: "SMARTSLIDE 18MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-SAI18",
        ITEM: "SMARTSLIDE A.I. 18MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-SM318",
        ITEM: "SMARTSLIDE 18MM (3 mtr)",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "3000 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-SMA15",
        ITEM: "SMARTSLIDE 15MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-EXT18",
        ITEM: "PLYWOOD 18MM EXTRO",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-EAI18",
        ITEM: "PLYWOOD 18MM EXTRO A.I.",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-EXT15",
        ITEM: "PLYWOOD 15MM EXTRO",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-SEN18",
        ITEM: "PLYWOOD 18MM SENKO",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-HBH18",
        ITEM: "HMCP BLACK HORSE 18MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2400 X 1200",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-FKK18",
        ITEM: "PLYWOOD FULL KAYU KERAS BLACK HORSE 18MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-FKK15",
        ITEM: "PLYWOOD FULL KAYU KERAS BLACK HORSE 15MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-WBP18",
        ITEM: "PLYWOOD WBP BLACK HORSE 18MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-MCB18",
        ITEM: "PLYWOOD MERANTI CAMPUR BLACK HORSE 18MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-MCB15",
        ITEM: "PLYWOOD MERANTI CAMPUR BLACK HORSE 15MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-BB18",
        ITEM: "BLOCKBOARD 18MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-BB15",
        ITEM: "BLOCKBOARD 15MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-BB12",
        ITEM: "BLOCKBOARD 12MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-MUL18",
        ITEM: "MULTIMIN 18MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-MUL15",
        ITEM: "MULTIMIN 15MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-MUL12",
        ITEM: "MULTIMIN 12MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-MUL9",
        ITEM: "MULTIMIN 9MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-MUL6",
        ITEM: "MULTIMIN 6MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-MUL3",
        ITEM: "MULTIMIN 3MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-HMR18",
        ITEM: "HMR 18MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "20"
    },
    {
        MATERIAL_CODE: "UTA-BOA-HMR15",
        ITEM: "HMR 15MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "15"
    },
    {
        MATERIAL_CODE: "UTA-BOA-HMR12",
        ITEM: "HMR 12MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-HMR9",
        ITEM: "HMR 9MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-HMR6",
        ITEM: "HMR 6MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-HMR3",
        ITEM: "HMR 3MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "10"
    },
    {
        MATERIAL_CODE: "UTA-BOA-MDF18",
        ITEM: "MDF 18MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "20"
    },
    {
        MATERIAL_CODE: "UTA-BOA-MDF15",
        ITEM: "MDF 15MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-MDF12",
        ITEM: "MDF 12MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-MDF9",
        ITEM: "MDF 9MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-MDF6",
        ITEM: "MDF 6MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-MDF3",
        ITEM: "MDF 3MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-BOA-TEAK3",
        ITEM: "TEAKWOOD 3MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "840fb0206aa24917bd39701feb6257d6",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-C1727",
        ITEM: "HPL CT 1727 T DELIGHT LINEN",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-C1728",
        ITEM: "HPL CT 1728 T CREAMY LINEN",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-C5990",
        ITEM: "HPL CT 5990 T ELM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-C0101",
        ITEM: "HPL CT 0101 T WHITE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-C0153",
        ITEM: "HPL CT 0153 F ICE WHITE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-C0206",
        ITEM: "HPL CT 0206 F BLACK STD",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-C5575",
        ITEM: "HPL CT 5575 T BURMA OAK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-C0150",
        ITEM: "HPL CT 0150 T NEW MAGNOLIA",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-C0117",
        ITEM: "HPL CT 0117 T DARK GREY",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-C1614",
        ITEM: "HPL CT 1614 G WHITE CARRERA",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-C5924",
        ITEM: "HPL CT 5924 T SAND ASH ",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-C6400",
        ITEM: "HPL CT 6400 SYHAM TEAK ",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-TH372",
        ITEM: "HPL TH 372 H NEW RHUMBA",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-TH357",
        ITEM: "HPL TH 357 H CALIFORNIA WALNUT",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-TH362",
        ITEM: "HPL 362 H MONO DELUXE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-TH006",
        ITEM: "HPL TH 006 AA MIDNIGHT GREY",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-TH014",
        ITEM: "HPL TH 014 AA LIGHT GREY",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-TH14G",
        ITEM: "HPL TH 014 G LIGHT GREY GLOSSY",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-TH14D",
        ITEM: "HPL TH 014 D LIGHT GREY DOVE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-TH037",
        ITEM: "HPL TH 037 AA CERAL",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-TH040",
        ITEM: "HPL TH 040 AA CHALK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-TH888",
        ITEM: "HPL TH 888 SL ASH RAMONE SLATE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-TH100",
        ITEM: "HPL TH 100 AA WINTER MAPLE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-TH135",
        ITEM: "HPL TH 135 AA SUNSET CONCORD",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-TH701",
        ITEM: "HPL TH 701 CR ABSOLUTE WHITE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-T1038",
        ITEM: "HPL TH 1038 B NEW NATURAL MAPLE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-T1235",
        ITEM: "HPL TH 1235 FA CREAM BRIXTER",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-T1236",
        ITEM: "HPL TH 1236 FA SMOKE BRIXTER",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-T1239",
        ITEM: "HPL TH 1239 FA AVENA LINEN",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-T1252",
        ITEM: "HPL TH 1252 FA ASTRAL ORDIN",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-T1251",
        ITEM: "HPL TH 1251 FA ZINC ORDIN",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-A04CY",
        ITEM: "HPL AS 14004 CY25 MEDIUM PROVENCE OAK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-A04CS",
        ITEM: "HPL AS 14004 CS16 MEDIUM PROVENCE OAK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-A00KM",
        ITEM: "HPL AS 13000 KM GLOSSY CHOKE WHITE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-AS07CN",
        ITEM: "HPL AS 13007 CN74 SMOOKY GRAY",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-A09CS",
        ITEM: "HPL AS 13009 CS89 BLACK LEATHER",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-A09CN",
        ITEM: "HPL AS 13009 CN74 BLACK DELICA",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-A08CS",
        ITEM: "HPL AS 14008 CS98 DARK EASTERN WALNUT",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-A16CS",
        ITEM: "HPL AS 14016 CS98 MEDIUM BERRY TEAK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-A27CS",
        ITEM: "HPL AS 14027 CS98 MEDIUM ORLLIA MAPLE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-A95CS",
        ITEM: "HPL AS 14095 CS98 DARK MODE WALNUT",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-A17CS",
        ITEM: "HPL AS 14117 CS98 LIGHT MODE WALNUT",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-A78CS",
        ITEM: "HPL AS 14078 CS89 DARK VINTAGE LEATHER",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-A21CS",
        ITEM: "HPL AS 14021 CS99 WHITE LEBANON CEDAR",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-A47KM",
        ITEM: "HPL AS 14037 KM GLOSSY DEEP ORIENTAL EBONY",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-A89CS",
        ITEM: "HPL AS 14089 CS83 NINJA",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-A56CY",
        ITEM: "HPL AS 14156 CY31 NATURAL FIRM OAK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-A02KN",
        ITEM: "HPL ASW 13002 KN74 PURE COOL WHITE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-A03KM",
        ITEM: "HPL ASW 13003 KM GLOSSY PURE CRYSTAL WHITE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-A26KM",
        ITEM: "HPL ASW 13026 KM GLOSSY PURE FOG WHITE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-I21CS",
        ITEM: "HPL INA 8121 CS16 OSCAR ZEBRA",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-A37CS",
        ITEM: "HPL AS 14137 CS98 LIGHT KAOURU SUGI",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-TH1ZP",
        ITEM: "TOUGHTOP HAK 14144 ZM83 PALE AURORA MARBLE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-O9860",
        ITEM: "HPL ORI 9860NV LIGHT CHINENSIS",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-O9861",
        ITEM: "HPL ORI 9861 T BROWN CHINENSIS",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-O6445",
        ITEM: "HPL ORI DH 6445 NV OFF WHITE TEX",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-O6444",
        ITEM: "HPL ORI DH 6444 NV PRIMARY TEX",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-O5322",
        ITEM: "HPL ORI DH 5322 NV OFF WHITE LINEN",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-GGS8G",
        ITEM: "HPL GLOBAL GS 8 CAYENNE GREY",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-H8GWG",
        ITEM: "HPL HM 8001 G WHITE GLOSSY",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-LW4HI",
        ITEM: "HPL LAMITAK WYA 4251K HIRO ITADORI ELM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-LD1BP",
        ITEM: "HPL LAMITAK DXO 1342 DC BRANDON PASHLEY",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-LD4GF",
        ITEM: "HPL LAMITAK DXO 4322 X GILLIAN FAUX DENIM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-LS1BY",
        ITEM: "HPL LAMITAK SCX 1154 D BLUEBERRY",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-HG777",
        ITEM: "HPL GREENLAM 777 SUMATRA TEAK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-HG257",
        ITEM: "HPL GREENLAM GSC 257 OLIVE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-HG148",
        ITEM: "HPL GREENLAM GSL 148 TIDAL",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-HG107",
        ITEM: "HPL GREENLAM GST 107 WHITE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-HG307",
        ITEM: "HPL GREENLAM WVB 5307 RUPTURED OAK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-HP451",
        ITEM: "HPL PLATINUM PC 451 T NATURAL BALSAM WOOD",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-FXB24",
        ITEM: "HPL FENIX BLACK NERO INGO (2440)",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-FXB30",
        ITEM: "HPL FENIX BLACK NERO INGO (3050)",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "3050 X 1300",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-PHB30",
        ITEM: "PHENOLIC NERO INGO (3050)",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "3050 X 1300 X 10",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-DH003",
        ITEM: "HPL DH003 CELLA COPPERTONE DECOMETAL",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220 X 1,3",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-WTOAK",
        ITEM: "VENEER WHITE OAK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "3000 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-WTOA2",
        ITEM: "VENEER WHITE OAK 2950 x 1220 MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2950 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-WTOA3",
        ITEM: "VENEER WHITE OAK 3050 x 1220 MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "3050 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-WTOA4",
        ITEM: "VENEER WHITE OAK 3200 x 1220 MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "3200 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-WTOA5",
        ITEM: "VENEER WHITE OAK 2800 x 1220 MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2800 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-WTOA6",
        ITEM: "VENEER WHITE OAK 2750 x 1220 MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2750 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-WTOAL",
        ITEM: "VENEER WHITE OAK LURUS 2440 x 1220 MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-WTASH",
        ITEM: "VENEER WHITE ASH",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "3170 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-WLNUT",
        ITEM: "VENEER WALNUT",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "3000 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-WLNT2",
        ITEM: "VENEER WALNUT 2",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "3400 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-WLNT3",
        ITEM: "VENEER WALNUT 3",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "3500 X 1200",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-W24JP",
        ITEM: "VENEER WALNUT 2440 (JASA PRESS)",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-W30JP",
        ITEM: "VENEER WALNUT 3050 (JASA PRESS)",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "3050 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-W36JP",
        ITEM: "VENEER WALNUT 3600 (JASA PRESS)",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "3600 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-KVRWT",
        ITEM: "KULIT VENEER WALNUT",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "9e4a884d4f3840caa58a4b42a2c4362b",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-JATI",
        ITEM: "VENEER JATI",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2600 X 1200",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-VEJA2",
        ITEM: "VENEER JATI 2540 X 1220",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2540 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-SUNGKA",
        ITEM: "VENEER SUNGKAI",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "3000 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-VESAP",
        ITEM: "VENEER SAPELE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "3250 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-VENYA",
        ITEM: "VENEER NYATOH",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-FN3MM",
        ITEM: "FANCY NTATOH 3 MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2440 X 1220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-VN260",
        ITEM: "VENEER NYATOH 2600 X 1220",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2600 X 1200",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-K8050",
        ITEM: "KERTASIVE OAKLEY WOOD KT 8050-O",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "122CM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-K3000",
        ITEM: "KERTASIVE CHARCOAL BLACK KT 3000-3",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "122CM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-K9101",
        ITEM: "KERTASIVE SADHA WOOD KTS-9101",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "122CM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-LAM-KT311",
        ITEM: "KERTASIVE SOFT GREEN KT-3000-11",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "5247f011f2174ede8200009034e6a35f",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "122CM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2T357",
        ITEM: "EDGING 22/1 TACO 357 H",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "23 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2T014",
        ITEM: "EDGING 22/1 TACO 014 G",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-4T357",
        ITEM: "EDGING 42/1 TACO 357 H",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "44 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2T006",
        ITEM: "EDGING 22/1 TH 006 MIDNIGHT GREY",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-4T006",
        ITEM: "EDGING 42/1 TH 006 MIDNIGHT GREY",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "42 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2T218",
        ITEM: "EDGING 22/1 TH 1218 BROWN DELUXE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-4T218",
        ITEM: "EDGING 42/1 TH 1218 BROWN DELUXE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "42 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2T217",
        ITEM: "EDGING 22/1 TH 217 BRILLIANT TEAK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-4T217",
        ITEM: "EDGING 42/1 TH 217 BRILLIANT TEAK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "42 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2L39X",
        ITEM: "EDGING LAMITAK WY 4239 X (23) EDUARD BAVARIAN OAK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "23 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2L40X",
        ITEM: "EDGING LAMITAK WY 4240 X (22) RAW AVANT OAK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "23 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-4L40X",
        ITEM: "EDGING LAMITAK WY 4240 X (42) RAW AVANT OAK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "42 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2L4242",
        ITEM: "EDGING LAMITAK WY 4242 X (22) HAZEL AVANT OAK ",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "23 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-4L4242",
        ITEM: "EDGING LAMITAK WY 4242 X (42) HAZEL AVANT OAK ",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "42 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2L38D",
        ITEM: "EDGING LAMITAK DXO 5338 D (22) STOFA GRIGIO",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "23 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2L51K",
        ITEM: "EDGING LAMITAK WYA 4251K (22) HIRO ITADORI ELM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "23 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-4L51K",
        ITEM: "EDGING LAMITAK WYA 4251K (42) HIRO ITADORI ELM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "44 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2L187",
        ITEM: "EDGING LAMITAK SHG 1187 (23) HIGH GLOSS PEARL",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "23 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2L154",
        ITEM: "EDGING LAMITAK SCX 1154 D (23) BLUEBERRY",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "23 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2C575",
        ITEM: "EDGING 22/1 CT 5575 T",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2C101",
        ITEM: "EDGING 22/1 CT 0101 T",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2C102",
        ITEM: "EDGING 22/1 CT 0101 T",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-4C101",
        ITEM: "EDGING 42/1 CT 0101 T",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "42 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-4C102",
        ITEM: "EDGING 42/1 CT 0101 T",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "42 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2C153",
        ITEM: "EDGING 22/1 CT 0153 ICE WHITE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-4C153",
        ITEM: "EDGING 42/1 CT 0153 ICE WHITE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "42 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2C852",
        ITEM: "EDGING 22/1 CT 7852 TAN WALNUT",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-4C852",
        ITEM: "EDGING 42/1 CT 7852 TAN WALNUT",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "42 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2C879",
        ITEM: "EDGING 22/1 CT 7879 GODERICH OAK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-4C879",
        ITEM: "EDGING 42/1 CT 7879 GODERICH OAK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "42 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2C206",
        ITEM: "EDGING 22/1 CT 0206 BLACK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2C163",
        ITEM: "EDGING 22/1 CT 0163 WARM WHITE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2C668",
        ITEM: "EDGING 22/1 CT 5668 WHITE BEECH",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2C479",
        ITEM: "EDGING 22/1 CT 6479 MELEMO ELM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2C708",
        ITEM: "EDGING 22/1 CT 6708 SANDY TEAK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-4C708",
        ITEM: "EDGING 42/1 CT 6708 SANDY TEAK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "42 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-4C786",
        ITEM: "EDGING HPL CT MANSONIA (42)",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "42 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2C786",
        ITEM: "EDGING HPL CT MANSONIA (22)",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2C117",
        ITEM: "EDGING CARTA 0117 DARK GREY (22)",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-4C856",
        ITEM: "EDGING CARTA 7856 KIRKWOOD TEAK (42)",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "42 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2C657",
        ITEM: "EDGING CARTA 6657 ZEKARTHO OAK (22)",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2C784",
        ITEM: "EDGING CARTA 7841 STEYR ASH (22)",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2C525",
        ITEM: "EDGING CARTA 5256 TEAK (22)",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2RE32",
        ITEM: "EDGING REHAU BLACK-032Z (23)",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "23mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2R703",
        ITEM: "EDGING 23/1 REHAU EICHE HELL 703W",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "23mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2R23B",
        ITEM: "EDGING 23/1 REHAU GREY 1723B",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "23mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2R769",
        ITEM: "EDGING 23/1 REHAU REISS MIRROR GLOSS 76911",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "23mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2R277",
        ITEM: "EDGING 23/1 REHAU TEX BROWN 2778B",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "23mm x 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-2FE29",
        ITEM: "EDGING BLACK FENIX NERO INGO (29)",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "29mm X 1 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-EKVSA",
        ITEM: "EDGING KULIT VENEER SAPELE",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "3250 X 50",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-EKVWA",
        ITEM: "EDGING KULIT VENEER WALNUT",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "3400 X 50",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-EKVW2",
        ITEM: "EDGING KULIT VENEER WALNUT 2600 X 50 MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2600 X 50",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-EKVW3",
        ITEM: "EDGING KULIT VENEER WALNUT 2650 X 390 MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2650 X 390",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-EKVW4",
        ITEM: "EDGING KULIT VENEER WALNUT 3600 X 300 MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "3600 X 300",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-EKVW5",
        ITEM: "EDGING KULIT VENEER WALNUT 3650 X 300 MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "3650 X 300",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-EKVW6",
        ITEM: "EDGING KULIT VENEER WALNUT 3750 X 280 MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "3750 X 280",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-EKVW7",
        ITEM: "EDGING KULIT VENEER WALNUT 22MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 X 0,45MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-KJ266",
        ITEM: "EDGING KULIT VENEER JATI 2600 X 160",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2600 X 160",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-KJ253",
        ITEM: "EDGING KULIT VENEER JATI 2500 X 130",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2500 X 130",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-KJ268",
        ITEM: "EDGING KULIT VENEER JATI 2600 X 180",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2600 X 180",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-KJ299",
        ITEM: "EDGING KULIT VENEER JATI 2900 X 190",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2900 X 190",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-EKVWO",
        ITEM: "EDGING KULIT VENEER WHITE OAK",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "2950 X 250",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-KVWO2",
        ITEM: "EDGING KULIT VENEER WHITE OAK 22MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "22 X 0,45MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-KVWO3",
        ITEM: "EDGING KULIT VENEER WHITE OAK 23MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "23 X 2700MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-KVWO4",
        ITEM: "EDGING KULIT VENEER WHITE OAK 44MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "44 X 2700MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-KVWO5",
        ITEM: "EDGING KULIT VENEER WHITE OAK 150 X 3100MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "150 X 3100MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-EKVOA",
        ITEM: "EDGING KULIT VENEER OAK (40)",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "2700 X 400",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-EKVNY",
        ITEM: "EDGING KULIT VENEER NYATOH",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "4200 X 180",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-EKVWB",
        ITEM: "EDGING KULIT VENEER WHITE BIRCH 30MM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "30 X 0,45MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-EHH19",
        ITEM: "EDGING HUBEN HITAM EA 19",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-EDG-E17DB",
        ITEM: "EDGING EA 17 DOF BESTEN",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "0a1344cddd4e4b47bb85f73e81389cd9",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-SOL-P1109",
        ITEM: "PAPAN PINUS 110 x 9 x 1 CM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "401a5783e5014fbb87a8f7d0b69d6937",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "110x9x1 CM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-SOL-KNYA3",
        ITEM: "KAYU NYATOH 3CM",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "401a5783e5014fbb87a8f7d0b69d6937",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "20 CM x 4 MTR",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "UTA-SOL-KWA84",
        ITEM: "KAYU WHITE ASH 8/4 FAS LUMBER",
        CATEGORY_ID: "91961361045f495cbbd84a89ac85b408",
        CATEGORY_SUB_ID: "401a5783e5014fbb87a8f7d0b69d6937",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "274,32X5,08X22,86CM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ADH-LPPRES",
        ITEM: "LEM PRESS PRESTO",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "PC3710VXX",
        MIN_STOCK: "40"
    },
    {
        MATERIAL_CODE: "PEN-ADH-LPSAK",
        ITEM: "LEM PRESS SAKATA",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "",
        MIN_STOCK: "10"
    },
    {
        MATERIAL_CODE: "PEN-ADH-LEDG",
        ITEM: "LEM EDGING",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "27b48b1541c1424f84de0bbc3e0cfddd",
        REMARKS: "ADINO HM 9580.0",
        MIN_STOCK: "1000"
    },
    {
        MATERIAL_CODE: "PEN-ADH-LKFOX",
        ITEM: "LEM KUNING FOX",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "PEN-ADH-LEMPU",
        ITEM: "LEM PU",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "ae71e4c8c24646dfa10a428f2c53172f",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ADH-HERIN",
        ITEM: "HERIN ",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "f4d24b2764e94ec9af9614c9422b1fdb",
        REMARKS: "PENGENCER LEM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ADH-SECLE",
        ITEM: "SEALANT CLEAR",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "ae71e4c8c24646dfa10a428f2c53172f",
        REMARKS: "300 ml",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ADH-SCNAS",
        ITEM: "SEALANT CLEAR NON ASAM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "ae71e4c8c24646dfa10a428f2c53172f",
        REMARKS: "300 ml",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ADH-SEPUT",
        ITEM: "SEALANT PUTIH",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "ae71e4c8c24646dfa10a428f2c53172f",
        REMARKS: "300 ml",
        MIN_STOCK: "2"
    },
    {
        MATERIAL_CODE: "PEN-ADH-SPNOA",
        ITEM: "SEALANT PUTIH NON ASAM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "ae71e4c8c24646dfa10a428f2c53172f",
        REMARKS: "300 ml",
        MIN_STOCK: "2"
    },
    {
        MATERIAL_CODE: "PEN-ADH-SELGR",
        ITEM: "SEALANT LIGHT GREY",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "ae71e4c8c24646dfa10a428f2c53172f",
        REMARKS: "280 gr",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ADH-SEHIT",
        ITEM: "SEALANT HITAM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "ae71e4c8c24646dfa10a428f2c53172f",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ADH-SECOK",
        ITEM: "SEALANT COKLAT",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "ae71e4c8c24646dfa10a428f2c53172f",
        REMARKS: "270 GR",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ADH-SI2BL",
        ITEM: "SIKAFLEX 221 BLACK",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "ae71e4c8c24646dfa10a428f2c53172f",
        REMARKS: "BLACK",
        MIN_STOCK: "2"
    },
    {
        MATERIAL_CODE: "PEN-ADH-SI2GR",
        ITEM: "SIKAFLEX 221 GREY",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "ae71e4c8c24646dfa10a428f2c53172f",
        REMARKS: "GREY",
        MIN_STOCK: "2"
    },
    {
        MATERIAL_CODE: "PEN-ADH-LPVC",
        ITEM: "LEM PVC",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "ae71e4c8c24646dfa10a428f2c53172f",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ADH-LTPVC",
        ITEM: "LEM TANGIT PVC",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "ae71e4c8c24646dfa10a428f2c53172f",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ADH-LAKER",
        ITEM: "LAKBAN KERTAS NACHI",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "24 MM x 20 YARD",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ADH-LABEN",
        ITEM: "LAKBAN BENING",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "2 INCH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ADH-LBN2I",
        ITEM: "LAKBAN BENING NACHI 2 INCH",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "2 INCH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ADH-LBG2I",
        ITEM: "LAKBAN BENING GAND 2 INCH",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "2 INCH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ADH-LALIS",
        ITEM: "LAKBAN LISTRIK",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "3/4 25 MTR",
        MIN_STOCK: "2"
    },
    {
        MATERIAL_CODE: "PEN-ADH-LACOK",
        ITEM: "LAKBAN COKLAT",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "2 INCH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ADH-F3MTA",
        ITEM: "FOAM 3M TAPE",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "1 INCH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ADH-DTAHI",
        ITEM: "DOUBLE TAPE HIJAU",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ADH-LETET",
        ITEM: "LEM TETES",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "20"
    },
    {
        MATERIAL_CODE: "PEN-ADH-FITAP",
        ITEM: "FIBERGLASS TAPE",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-SPKAY",
        ITEM: "SPIL AMBALAN KAYU (MAORI)",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "18-19 mm",
        MIN_STOCK: "10"
    },
    {
        MATERIAL_CODE: "PEN-ACC-SAAB5",
        ITEM: "SPIL AMBALAN KAYU HUBEN BENING AB-5",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-SABHU",
        ITEM: "SPIL AMBALAN BESI HUBEN",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-JJ193",
        ITEM: "RAK AMBALAN TAMBAHAN JJ1930 90 X 30CM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "f82f4004e223497a915848c89d8a3d76",
        REMARKS: "90 X 30CM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-HATUB",
        ITEM: "HANGER TUBE POLOS",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "3000 mm",
        MIN_STOCK: "10"
    },
    {
        MATERIAL_CODE: "PEN-ACC-HTLAM",
        ITEM: "HANGER TUBE LAMPU",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "3000 MM",
        MIN_STOCK: "10"
    },
    {
        MATERIAL_CODE: "PEN-ACC-BOHAN",
        ITEM: "BRACKET OVAL HANGER",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "20"
    },
    {
        MATERIAL_CODE: "PEN-ACC-BTVP4",
        ITEM: "BRACKET TV SWIVEL NB P4",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "f82f4004e223497a915848c89d8a3d76",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-BTV46",
        ITEM: "BRACKET TV SLIM UNIVERSAL ALL TV 46 INCH YR-098",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "f82f4004e223497a915848c89d8a3d76",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-BTV42",
        ITEM: "BRACKET TV LED 42 INCH LI-102",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "f82f4004e223497a915848c89d8a3d76",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-FLEDH",
        ITEM: "FRAME LED HITAM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "2450 MM",
        MIN_STOCK: "10"
    },
    {
        MATERIAL_CODE: "PEN-ACC-FLH24",
        ITEM: "FRAME LED HITAM 2CM RULAM 24",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-FLEDS",
        ITEM: "FRAME LED SILVER",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "2450 MM",
        MIN_STOCK: "10"
    },
    {
        MATERIAL_CODE: "PEN-ACC-FLS27",
        ITEM: "FRAME LED SILVER 2CM LC 027",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-FLSH3",
        ITEM: "FRAME LED SUDUT HITAM 034 3MTR",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "3 MTR",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-FLSS1",
        ITEM: "FRAME LED SUDUT SILVER 1MTR",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "1 MTR",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-FLS2M",
        ITEM: "FRAME LED SUDUT 2MTR",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "2 MTR",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-LUA12",
        ITEM: "LIST U ALUM 1/2",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "3 MTR",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-MOABU",
        ITEM: "MOHAIR ABU",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-MOCOK",
        ITEM: "MOHAIR COKLAT",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-DSKAR",
        ITEM: "DOOR SEAL KARET",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "3 MTR",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-DSBUL",
        ITEM: "DOOR SEAL BULU",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-DWSHG",
        ITEM: "DOOR WINDOW SEAL HITAM GARIS 2,5 MTR",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "2,5 MTR",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-VG417",
        ITEM: "VENT GRILL 4 x 17",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "4 X 17CM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-VG815",
        ITEM: "VENT GRILL 8 x 15",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "8 X 15CM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-VG835",
        ITEM: "VENT GRILL 8 x 35",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "8 X 35CM",
        MIN_STOCK: "10"
    },
    {
        MATERIAL_CODE: "PEN-ACC-VG840",
        ITEM: "VENT GRILL 8 x 40",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "8 X 40CM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-VGBPU",
        ITEM: "VENT GRILL BULAT PUTIH",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-HLH03",
        ITEM: "HANDLE LH 03 (75290)",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-HP332",
        ITEM: "HANDLE PALOMA HRP 332",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "MATTE BLACK",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-HH26C",
        ITEM: "HANDLE HITAM 26 CM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "BLACK",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-HHS20",
        ITEM: "HANDLE HUBEN SILVER 20 CM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "SILVER",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-HHS17",
        ITEM: "HANDLE HUBEN SILVER 17 CM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "SILVER",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-HG162",
        ITEM: "HANDLE GOLD TEXTURED 162 mm",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "162mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-HHT10",
        ITEM: "HANDLE HUBEN TPA - 10",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "192mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-HA248",
        ITEM: "HANDLE PINTU ANTIK BRASS A 248",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-H5028",
        ITEM: "HANDLE PINTU DEKSON 5028 MATT BLACK",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "MATT BLACK",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-HP802",
        ITEM: "HANDLE PULL DEKSON DELUXE PH DL802",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "25 X 400 X 300",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-HBE1M",
        ITEM: "HANDLE BLACK EVE 1 MTR",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "BLACK",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-HATAN",
        ITEM: "HANDLE TANAM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-HA377",
        ITEM: "HANDLE ALUM LP 377 BLACK",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-HTPPH",
        ITEM: "HANDLE TANAM PROFIL PINGGIR HITAM 106MM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "BLACK",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-HKNKA",
        ITEM: "HANDLE KNOB KAYU",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-HDH35",
        ITEM: "HANDLE DOOR PULL GAWANG HITAM 35CM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "BLACK",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-H4997",
        ITEM: "HANDLE OVAL 1 INCH P35 HK 4997",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-SEMI3",
        ITEM: "SELOT MILANO 3\"",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "3\"",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-GS004",
        ITEM: "GRENDEL SELOT 004 / HK 2 INCH",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "2 INCH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-FRAS4",
        ITEM: "FRAME S4",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-CSFBG",
        ITEM: "CAB SUS FITTING (BRACKET GANTUNG)",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-SPBCA",
        ITEM: "SUPPORT PLATE (BRACELET CAMAR)",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-PSLKA",
        ITEM: "PLAT SIKU L KARET",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "10"
    },
    {
        MATERIAL_CODE: "PEN-ACC-PLSIL",
        ITEM: "PLAT SIKU L",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "2 CM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-PS100",
        ITEM: "PLAT SIKU 100MM X 100MM ",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "100 X 100",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-PS125",
        ITEM: "PLAT SIKU 125MM X 125MM ",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "125mmx125mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-PSA15",
        ITEM: "PLAT SIKU A 150 X 300MM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "150 X 300MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-SKSPS",
        ITEM: "SIKU KARET SILIKON PENGAMAN SUDUT",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-KSKC2",
        ITEM: "KAKI SPONS KOTAK COKLAT 2,5CM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "2,5CM COKLAT",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-DOSWI",
        ITEM: "DOOR SWITCH",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-SPIHA",
        ITEM: "SWITCH PIRAMID HARFIT",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-HOCO3",
        ITEM: "HONEYCOMB 3 CM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "1x2 mtr",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-MKSWI",
        ITEM: "MAGNET KACA SINGLE WINSTONS",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-RONYL",
        ITEM: "RODA NYLON",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-RNY50",
        ITEM: "RODA NYLON 50",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-RNY25",
        ITEM: "RODA NYLON COAK 25MM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-RCAMI",
        ITEM: "RODA CASTER MINI SR 32",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-RO688",
        ITEM: "RODA 688",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-R380B",
        ITEM: "RODA 380 BESTEN",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-RHRD5",
        ITEM: "RODA HITAM RUBBER DIA. 5CM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "DIA. 5CM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-RNR2I",
        ITEM: "RODA NYLON RANGER REM TUSUK 2 INCH",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "2 INCH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-C1520",
        ITEM: "WIRE CABLE DRAG CHAIN 15x20MM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "15 x 20 MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-MN8X3",
        ITEM: "MAGNET NEODYMIUM 8X3MM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "8X3 MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-MNH15",
        ITEM: "MAGNET NEODYMIUM HOLE 15 X 3 X 4MM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "15 X 3 X 4MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-MAGHA",
        ITEM: "MAGNET HARFIT",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-MIK10",
        ITEM: "MATA ITIK KECIL 10 X 10",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "10 X 10 BH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-MIK12",
        ITEM: "MATA ITIK 12MM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "12MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-MIK20",
        ITEM: "MATA ITIK 20MM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "20MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-ACC-LK145",
        ITEM: "LAHER KOTAK 14,5 CM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "087a02dbfa15447f88761f6e001c818e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-SK438",
        ITEM: "SKRUP 04 x 3/8",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "04 x 3/8",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-SK1CM",
        ITEM: "SKRUP 1CM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-SK1,5KU",
        ITEM: "SKRUP 1,5CM KURUS",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "06 x 5/8",
        MIN_STOCK: "1000"
    },
    {
        MATERIAL_CODE: "PEN-CON-SK1,5GE",
        ITEM: "SKRUP 1,5CM GEMUK",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "08 x 5/8",
        MIN_STOCK: "500"
    },
    {
        MATERIAL_CODE: "PEN-CON-SK2KU",
        ITEM: "SKRUP 2CM KURUS",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "06 x 3/4",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-SK2,5KU",
        ITEM: "SKRUP 2,5CM KURUS",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "06 x 1",
        MIN_STOCK: "1000"
    },
    {
        MATERIAL_CODE: "PEN-CON-SK2,5GE",
        ITEM: "SKRUP 2,5CM GEMUK",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "08 x 1",
        MIN_STOCK: "1000"
    },
    {
        MATERIAL_CODE: "PEN-CON-SK3KU",
        ITEM: "SKRUP 3CM KURUS",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "06 x 1 1/4",
        MIN_STOCK: "1000"
    },
    {
        MATERIAL_CODE: "PEN-CON-SK3GE",
        ITEM: "SKRUP 3CM GEMUK",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "08 x 1 1/4",
        MIN_STOCK: "1000"
    },
    {
        MATERIAL_CODE: "PEN-CON-SK4KU",
        ITEM: "SKRUP 4CM KURUS",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "06 x 1 1/2",
        MIN_STOCK: "1000"
    },
    {
        MATERIAL_CODE: "PEN-CON-SK4GE",
        ITEM: "SKRUP 4CM GEMUK",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "08 x 1 1/2",
        MIN_STOCK: "1000"
    },
    {
        MATERIAL_CODE: "PEN-CON-SK5KU",
        ITEM: "SKRUP 5CM KURUS",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "06 x 2",
        MIN_STOCK: "1000"
    },
    {
        MATERIAL_CODE: "PEN-CON-SK5GE",
        ITEM: "SKRUP 5CM GEMUK",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "08 x 2",
        MIN_STOCK: "1000"
    },
    {
        MATERIAL_CODE: "PEN-CON-SK7CM",
        ITEM: "SKRUP 7CM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "08 x 3",
        MIN_STOCK: "300"
    },
    {
        MATERIAL_CODE: "PEN-CON-SG3CM",
        ITEM: "SKRUP GYPSUM 3 CM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "0d90e94307e240acae428c0c579e9272",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-SG3CS",
        ITEM: "SKRUP GYPSUM 3 CM (SATUAN)",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-SG2,5CM",
        ITEM: "SKRUP GYPSUM 2,5 CM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-SG4CM",
        ITEM: "SKRUP GYPSUM 4 CM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-SP2,5CM",
        ITEM: "SKRUP PHILIP 2,5 CM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "10 x 1",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-SP4CM",
        ITEM: "SKRUP PHILIP 4 CM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "10 x 1 1/4",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-SK310",
        ITEM: "SKRUP JFL 3 X 10",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-SJ315",
        ITEM: "SKRUP JP 3 X 15",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-JFM41",
        ITEM: "SKRUP JF M4 X 10",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-MUM10",
        ITEM: "MUR M10",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-DYM10",
        ITEM: "DYNABOLT M10",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-DWL",
        ITEM: "DOWEL",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "500"
    },
    {
        MATERIAL_CODE: "PEN-CON-MNFX",
        ITEM: "MINIFIX",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "3,5 cm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-CMNFX",
        ITEM: "CAM MINIFIX",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "D 1,5 cm",
        MIN_STOCK: "20"
    },
    {
        MATERIAL_CODE: "PEN-CON-SNMNFX",
        ITEM: "SOCKET NILON MINIFIX",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "1 cm",
        MIN_STOCK: "20"
    },
    {
        MATERIAL_CODE: "PEN-CON-FIS6",
        ITEM: "FISHER S6",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "300"
    },
    {
        MATERIAL_CODE: "PEN-CON-FISGY",
        ITEM: "FISHER GYPSUM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-BMHAF",
        ITEM: "BRACKET MODULAR HAFELE",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "13 mm",
        MIN_STOCK: "50"
    },
    {
        MATERIAL_CODE: "PEN-CON-SCPSK",
        ITEM: "STICKER COKLAT PENUTUP SKRUP",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "D 2 cm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-TSPUT",
        ITEM: "TUTUP SKRUP PUTIH",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "100"
    },
    {
        MATERIAL_CODE: "PEN-CON-TSCOK",
        ITEM: "TUTUP SKRUP COKLAT",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "100"
    },
    {
        MATERIAL_CODE: "PEN-CON-PTF30",
        ITEM: "PAKU TEMBAK F30",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "1d2b0d9bfbf94bcfab87c0af0d30e0a3",
        REMARKS: "30mm",
        MIN_STOCK: "25"
    },
    {
        MATERIAL_CODE: "PEN-CON-PTF25",
        ITEM: "PAKU TEMBAK F25",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "1d2b0d9bfbf94bcfab87c0af0d30e0a3",
        REMARKS: "25mm",
        MIN_STOCK: "25"
    },
    {
        MATERIAL_CODE: "PEN-CON-JJS25",
        ITEM: "PAKU TEMBAK F25 JJS",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "1d2b0d9bfbf94bcfab87c0af0d30e0a3",
        REMARKS: "25mm",
        MIN_STOCK: "25"
    },
    {
        MATERIAL_CODE: "PEN-CON-PTF20",
        ITEM: "PAKU TEMBAK F20",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "1d2b0d9bfbf94bcfab87c0af0d30e0a3",
        REMARKS: "20mm",
        MIN_STOCK: "25"
    },
    {
        MATERIAL_CODE: "PEN-CON-PTF15",
        ITEM: "PAKU TEMBAK F15",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "1d2b0d9bfbf94bcfab87c0af0d30e0a3",
        REMARKS: "15mm",
        MIN_STOCK: "25"
    },
    {
        MATERIAL_CODE: "PEN-CON-PTF10",
        ITEM: "PAKU TEMBAK F10",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "1d2b0d9bfbf94bcfab87c0af0d30e0a3",
        REMARKS: "10mm",
        MIN_STOCK: "25"
    },
    {
        MATERIAL_CODE: "PEN-CON-PACAC",
        ITEM: "PAKU CACING",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-BPA16",
        ITEM: "BESI PASAK AMBALAN 16CM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "16cm",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "PEN-CON-BAR25",
        ITEM: "BESI AMBALAN RAMSET 25CM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "25cm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-CAUDA",
        ITEM: "CAPIT UDANG",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-CUD38",
        ITEM: "CAPIT UDANG DRC 38MM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "38MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-CUG35",
        ITEM: "CAPIT UDANG GOLD 35MM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "35MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-CUG40",
        ITEM: "CAPIT UDANG GOLD 40MM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "40MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-CUG45",
        ITEM: "CAPIT UDANG GOLD 45MM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "45MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-CUG70",
        ITEM: "CAPIT UDANG GOLD 70MM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "70MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-CAUSI",
        ITEM: "CAPIT UDANG SILVER",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PEN-CON-CUD49",
        ITEM: "CAPIT UDANG DC 49MM",
        CATEGORY_ID: "162eba8cdbe74d7c8459628e291d9b00",
        CATEGORY_SUB_ID: "7b99dd76425a4b17adafc003202ae340",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "49MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-KLEM7",
        ITEM: "KLEM KABEL NO 7",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-KLEM8",
        ITEM: "KLEM KABEL NO 8",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-TSSKP",
        ITEM: "TERMINAL SOCKET SAMBUNGAN KABEL PUTIH",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "PUTIH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-TJKKB",
        ITEM: "TERMINAL JUMPER KONEKTOR KABEL BIRU",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "BIRU",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-KD15F",
        ITEM: "KABEL DUCTING 100 X 50 X 170 CM FUKUSIMA",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "100 X 50 X 170 CM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LLSHI",
        ITEM: "LAMPU LED STRIP HILED 3000K",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "5000mm",
        MIN_STOCK: "10"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LLSH4",
        ITEM: "LAMPU LED STRIP HILED 4000K",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "5000mm",
        MIN_STOCK: "10"
    },
    {
        MATERIAL_CODE: "MEP-LIG-CO123",
        ITEM: "LAMPU LED STRIP HILED COB 12V 3000K",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "5000mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LSH24",
        ITEM: "LAMPU LED STRIP HILED COB 24V 3000K",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "5000mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-C244K",
        ITEM: "LAMPU LED STRIP HILED COB 24V 4000K",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "5000mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LLSKI",
        ITEM: "LAMPU LED STRIP KINGTAS 3000K",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "5000mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LLSP3",
        ITEM: "LAMPU LED STRIP PANASONIC 3000K",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "5000mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LLSP4",
        ITEM: "LAMPU LED STRIP PANASONIC 4000K",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "5000mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LLSY3",
        ITEM: "LAMPU LED STRIP YAMASAKI WW 3000K",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "5000mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LLSY4",
        ITEM: "LAMPU LED STRIP YAMASAKI NW 4000K",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "5000mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LLSX3",
        ITEM: "LAMPU LED STRIP HINOLUX 3000K",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "5000mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LSPH3",
        ITEM: "LAMPU LED STRIP PHILIPS 3000K",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "5000mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LLSM3",
        ITEM: "LAMPU LED STRIP MORGEN 3000K",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "5000mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LLSI3",
        ITEM: "LAMPU LED STRIP INLITE INFS014 3000K",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "5000mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LLSI4",
        ITEM: "LAMPU LED STRIP INLITE INFS014 4000K",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "5000mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LLSPW",
        ITEM: "LAMPU LED STRIP PHILIP WIFI 2M 1600LM",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LLSPO",
        ITEM: "LAMPU LED SPOT IN-LITE",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "In-lite warm white",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LLS7P",
        ITEM: "LAMPU LED SPOT 7W PHILIPS",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "Philips 2700K",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LLBP3",
        ITEM: "LAMPU LED BULB PHILIPS 3000K",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "Philips 3000K",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-BL910",
        ITEM: "LAMPU LED BULB BL910 BRIGHTLITE 4000K",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "BL910 4000K",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LS001",
        ITEM: "LED SPOTLIGHT BULAT AR 001 BLACK 3000K",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "AR 001 BLACK 3000K",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LDDWP",
        ITEM: "LED DOWNLIGHT DL190B WHITE PHILIPS",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "DL190B WHITE",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-AR208",
        ITEM: "ARTALUX DOWNLIGHT OB 2,5 INCH AR208 BULAT WHITE",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "AR208 BULAT WHITE",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-BDBSL",
        ITEM: "BASEUS DGIWK-B SCREEN LIGHT",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "BLACK",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-KLDGO",
        ITEM: "KAP LAMPU DINDING GOLD",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "GOLD",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-TRA3A",
        ITEM: "TRAVO 3A HILED",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "12V",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "MEP-LIG-TRA5A",
        ITEM: "TRAVO 5A HILED",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "12V",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "MEP-LIG-TRA10",
        ITEM: "TRAVO 10A HILED",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "12V",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "MEP-LIG-TRA20",
        ITEM: "TRAVO 20,8A HILED",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "12V",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-T1024",
        ITEM: "TRAVO 10,4A 24V HILED",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "24V",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-TR424",
        ITEM: "TRAVO 4,2A 24V HILED",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "24V",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-KLHME",
        ITEM: "KABEL LED HITAM MERAH",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "2 x 0,5 mm",
        MIN_STOCK: "30"
    },
    {
        MATERIAL_CODE: "MEP-LIG-KNHIT",
        ITEM: "KABEL NYA HITAM",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "1 X 1,5mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-KNKUN",
        ITEM: "KABEL NYA KUNING",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "1 X 1,5mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-KNBIR",
        ITEM: "KABEL NYA BIRU",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "1 X 1,5mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-KNYYH",
        ITEM: "KABEL NYYHY",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "2 X 0,75 HITAM",
        MIN_STOCK: "30"
    },
    {
        MATERIAL_CODE: "MEP-LIG-KT315",
        ITEM: "KABEL TUNGGAL NYM 3x1,5",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "3 x 1,5 PUTIH",
        MIN_STOCK: "20"
    },
    {
        MATERIAL_CODE: "MEP-LIG-KSACH",
        ITEM: "KABEL SOCKET AC HITAM",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-KSA2H",
        ITEM: "KABEL SOCKET AC 2 HITAM",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-PSHIT",
        ITEM: "POWER SOCKET HITAM",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SEBA3",
        ITEM: "SELANG BAKAR 3MM",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "3MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SEBA5",
        ITEM: "SELANG BAKAR 5MM",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "5MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-STPSI",
        ITEM: "SAKLAR TUNGGAL PANASONIC SILVER",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "PANASONIC SILVER",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-STPPU",
        ITEM: "SAKLAR TUNGGAL PANASONIC PUTIH",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "PANASONIC PUTIH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SDPPU",
        ITEM: "SAKLAR DOUBLE PANASONIC PUTIH",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "PANASONIC PUTIH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SSKPH",
        ITEM: "SAKLAR STOP KONTAK PANASONIC HITAM",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "PANASONIC HITAM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SKUNG",
        ITEM: "STOP KONTAK UNIVERSAL NERO GRAY",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "NERO GRAY",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SKN1G",
        ITEM: "SAKLAR NERO V11 BLACK 1 GANG",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "NERO V11 TITANIUM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SKN2G",
        ITEM: "SAKLAR NERO V11 BLACK 2 GANG",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "NERO V11 TITANIUM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-S4GZS",
        ITEM: "SAKLAR 4 GANG ZENCELO SCHNEIDER",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-STUZS",
        ITEM: "SAKLAR TUNGGAL ZENCELO SCHNEIDER",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "BRONZER",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SDOZS",
        ITEM: "SAKLAR DOUBLE ZENCELO SCHNEIDER",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "BRONZER",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-STRZS",
        ITEM: "SAKLAR TRIPLE ZENCELO SCHNEIDER",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "BRONZER",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SDPLS",
        ITEM: "SAKLAR DOUBLE PIENO SCHNEIDER LAVENDAR SILVER",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "E8232L1F",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SATRIP",
        ITEM: "SAKLAR TRIPPLE",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "PANASONIC PUTIH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SSLOO",
        ITEM: "SAKLAR SWITCH LED ON OFF PUTIH",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "PUTIH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SSOBH",
        ITEM: "SAKLAR SWITCH ON OFF BULAT HITAM",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "BULAT HITAM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SSKH3",
        ITEM: "SAKLAR SWITCH KOTAK HITAM 3 GEAR 5-15V",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "KOTAK HITAM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-STKON",
        ITEM: "STOP KONTAK",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "PANASONIC PUTIH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SKPPU",
        ITEM: "STOP KONTAK PANASONIC PUTIH",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "PANASONIC PUTIH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SKOOW",
        ITEM: "STOP KONTAK OUTBOW",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "BROCO ABU",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SKO15",
        ITEM: "STOP KONTAK OUTBOW 15410",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "BROCO PUTIH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SKV11",
        ITEM: "STOP KONTAK NERO V11 BLACK",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "NERO V11 TITANIUM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SKOZS",
        ITEM: "STOP KONTAK ZENCELO SCHNEIDER",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "BRONZER",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SKPLS",
        ITEM: "STOP KONTAK PIENO SCHNEIDER LAVENDAR SILVER",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "E82426_16S",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SKLSW",
        ITEM: "STOP KONTAK LEONA SCHNEIDER WHITE",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "WHITE",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SK4LU",
        ITEM: "STOP KONTAK 4 LUBANG",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "TANPA KABEL",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SAPPU",
        ITEM: "SOCKET ANTENA PANASONIC PUTIH",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "PANASONIC PUTIH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-STSPU",
        ITEM: "SOCKET TELEPHONE SCHNEIDER PUTIH",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "SCHNEIDER PUTIH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-STSPP",
        ITEM: "SOCKET TELEPHONE PANASONIC PUTIH",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "PANASONIC PUTIH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-KHCOK",
        ITEM: "KABEL HOLE COKLAT",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "60 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-KHHIT",
        ITEM: "KABEL HOLE HITAM",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "60 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-KHABU",
        ITEM: "KABEL HOLE ABU",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "60 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-KHPUT",
        ITEM: "KABEL HOLE PUTIH",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "60 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-KHSIL",
        ITEM: "KABEL HOLE SILVER",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "60 mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LK816",
        ITEM: "LUBANG KABEL KOTAK 8 x 16 CM",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "8 x 16 CM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-LAUVC",
        ITEM: "LAMPU UVC",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "PHILIPS",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-SBRHI",
        ITEM: "STEKER BROCO HITAM",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "PUTIH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-MF456",
        ITEM: "MOTOR FAN EBMPAPST 4560N BLACK",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "BLACK",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-LIG-UFEF4",
        ITEM: "UNIVERSAL FILTER EXHAUST FAN 4 INCH WHITE",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "54cf7ab9fc114c70b20cbe5db975cf37",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "WHITE",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-ELBLU",
        ITEM: "ENGSEL LURUS BLUMOTION",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "75B1550 BCOR, 107O",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-ELNSB",
        ITEM: "ENGSEL LURUS NON SLOWMOTION BLUM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "75T1550 BCOR",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-ELUBL",
        ITEM: "ENGSEL LURUS UNSPRUNG BLUM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "70T9550 TL BCOR",
        MIN_STOCK: "20"
    },
    {
        MATERIAL_CODE: "HDW-FIT-ELOBB",
        ITEM: "ENGSEL LURUS ONYX BLACK BLUM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "75B1550 ONS",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EBL155",
        ITEM: "ENGSEL 155 DEGREE BLUM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "71B7550 BCOR",
        MIN_STOCK: "16"
    },
    {
        MATERIAL_CODE: "HDW-FIT-ELB170",
        ITEM: "ENGSEL 170 DEGREE LURUS BLUM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "7TT6550 TL NI",
        MIN_STOCK: "8"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EST170",
        ITEM: "ENGSEL 170 DEGREE SETENGAH TEKUK BLUM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EBBLU",
        ITEM: "ENGSEL BIFOLD BLUM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "79T8500 NI",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-E12TU",
        ITEM: "ENGSEL 1/2 TEKUK UNSPRUNG BLUM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "74T1650.TL",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EFTUB",
        ITEM: "ENGSEL FULL TEKUK UNSPRUNG BLUM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "75B1750MB V250 NI",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EFTBL",
        ITEM: "ENGSEL FULL TEKUK BLUMOTION",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-ETBTA",
        ITEM: "ENGSEL FULL TEKUK BLUMOTION (TANPA ACCESSORIES)",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EBCBL",
        ITEM: "ENGSEL BLIND CORNER BLUM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "79B9550",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EAF95",
        ITEM: "ENGSEL ALU FRAME 95 DEGREE BLUM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EABLU",
        ITEM: "ENGSEL AVENTOS BLUM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "78Z5500",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-LUFGV",
        ITEM: "ENGSEL LURUS FGV",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EWFGV",
        ITEM: "ENGSEL WAYANG FGV",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-LUBES",
        ITEM: "ENGSEL LURUS BESTEN",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EFTBE",
        ITEM: "ENGSEL FULL TEKUK BESTEN",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-ELHUB",
        ITEM: "ENGSEL LURUS HUBEN",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EFTHU",
        ITEM: "ENGSEL FULL TEKUK HUBEN",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EFTFE",
        ITEM: "ENGSEL FULL TEKUK FERRARI",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-ELKNO",
        ITEM: "ENGSEL LURUS KNOCKERS",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-ETLHA",
        ITEM: "ENGSEL TENDANG LURUS HAFELE",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EDSUG",
        ITEM: "ENGSEL DOWNSTAY SUGATSUNE",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "SDH 001",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EDDSU",
        ITEM: "ENGSEL DROP DOWNWARD SUGATSUNE",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "SDHP",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-SS100",
        ITEM: "SOFTDOWNSTAY SUGATSUNE 100",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "SDSC100",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-G60TW",
        ITEM: "GASPRING 10x60N TWIN",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-G80TW",
        ITEM: "GASPRING 10x80N TWIN",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-GT150",
        ITEM: "GASPRING TWIN 150N",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-GH100",
        ITEM: "GASPRING HUBEN 100N",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EP18M",
        ITEM: "ENGSEL PIANO 1,8 MTR",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "PJG. 1,8 MTR",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EPKAC",
        ITEM: "ENGSEL PIVOT KACA",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EHDRA",
        ITEM: "ENGSEL HIDDEN DOOR RAVES",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "EX 5825",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-ED80B",
        ITEM: "ENGSEL TANAM DEKSON D80 MATT BLACK",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "D80 BLACK MATT",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-ECD80",
        ITEM: "ENGSEL TANAM ADJUSTABLE ES CONC D80 NA",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "CONC D80 NA",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-ET8PP",
        ITEM: "ENGSEL TANAM IHP 801 P40 NA PALOMA",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-FHD84",
        ITEM: "FLOOR HINGE HEAVY DUTY DEKSON FH 84 SSS",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "FH 84 SSS",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-FHD80",
        ITEM: "FLOOR HINGE HEAVY DUTY DEKSON FH 80 SSS",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "FH 80 SSS",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EC4IN",
        ITEM: "ENGSEL COBBY 4 INCH",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-ESL95",
        ITEM: "ENGSEL SISIR LIPAT TANAM 95MM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "95MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-ES45L",
        ITEM: "ENGSEL SISIR LIPAT TANAM 45MM LUFKIN",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "45MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-ES45T",
        ITEM: "ENGSEL SISIR LIPAT TANAM 45MM TWIN",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "45MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-K3527",
        ITEM: "ENGSEL KUPU-KUPU 3,5x2,7 CM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "3,5 x 2,7 CM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EKK5D",
        ITEM: "ENGSEL KUPU-KUPU 5 INCH DEKKSON",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "NRP ESS 316 5x3x4mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EKR53",
        ITEM: "ENGSEL KUPU-KUPU RAFES 5x3x3,5",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "5 x 3 x 3,5",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EK3AL",
        ITEM: "ENGSEL KUPU-KUPU 3\" ALBION",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "3\"",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-ET96L",
        ITEM: "ENGSEL T 96 LURUS",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "UNTUK KACA",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-ER339",
        ITEM: "ENGSEL RANJANG 339-1",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "f82f4004e223497a915848c89d8a3d76",
        REMARKS: "UNTUK RANJANG",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-EAL14",
        ITEM: "ENGSEL AMBALAN LIPAT PER 14 INCH",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-BL500",
        ITEM: "REL LACI TANDEM  500 BLUM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "560H5000",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-BL450",
        ITEM: "REL LACI TANDEM 450 BLUM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "560H4500",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-T4550",
        ITEM: "REL LACI TANDEM 450 BLUM 50KG",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "566H4500",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-BL400",
        ITEM: "REL LACI TANDEM 400 BLUM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "560H4000",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-BL350",
        ITEM: "REL LACI TANDEM 350 BLUM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "560H3500",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-T35TO",
        ITEM: "REL LACI TANDEM 350 BLUM FULL EXTENSION TIP ON",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "560H3500B",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-BL300",
        ITEM: "REL LACI TANDEM 300 BLUM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "560H3000",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-T30SE",
        ITEM: "REL LACI TANDEM 300 BLUM SINGLE EXTENSION",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "550H3000B",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-BP500",
        ITEM: "REL LACI TANDEM  500 BLUM PUSH OPEN",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "760H5000",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-BP450",
        ITEM: "REL LACI TANDEM 450 BLUM PUSH OPEN",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "760H4500",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-BP400",
        ITEM: "REL LACI  TANDEM 400 BLUM PUSH OPEN",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "760H4000",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-BP350",
        ITEM: "REL LACI  TANDEM 350 BLUM PUSH OPEN",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "760H3500",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-BP300",
        ITEM: "REL LACI TANDEM 300 BLUM PUSH OPEN",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "760H3000",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TH500",
        ITEM: "REL LACI TANDEM  500 HUBEN",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "50 cm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TH450",
        ITEM: "REL LACI TANDEM 450 HUBEN",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "45 cm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TH400",
        ITEM: "REL LACI  TANDEM 400 HUBEN",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "40 cm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TH300",
        ITEM: "REL LACI TANDEM 300 HUBEN",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "30 cm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TE500",
        ITEM: "REL LACI TANDEM 500 HETTICH",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "50 cm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TE350",
        ITEM: "REL LACI TANDEM 350 HETTICH",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "35 cm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TE300",
        ITEM: "REL LACI TANDEM 300 HETTICH",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "30 cm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TF300",
        ITEM: "REL LACI TANDEM SINGLE 300 HAFELE",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "30 cm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-RTF30",
        ITEM: "REL LACI TANDEM 300 HAFELE",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "30 cm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-DT550",
        ITEM: "REL LACI DOUBLE TRACK 550",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "55CM HUBEN",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-DT500",
        ITEM: "REL LACI DOUBLE TRACK 500",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "50CM HUBEN",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-DTS5T",
        ITEM: "REL LACI DOUBLE TRACK SLOWMOTION 500 TACO",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "50CM TACO",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-DT450",
        ITEM: "REL LACI DOUBLE TRACK 450",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "45CM HUBEN",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-DT400",
        ITEM: "REL LACI DOUBLE TRACK 400",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "40CM HUBEN",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-DT350",
        ITEM: "REL LACI DOUBLE TRACK 350",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "35CM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-DT35H",
        ITEM: "REL LACI DOUBLE TRACK 350 PUSH OPEN HARFIT",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "35CM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-DT35N",
        ITEM: "REL LACI DOUBLE TRACK 350 PUSH OPEN HUBEN",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "35CM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-DT300",
        ITEM: "REL LACI DOUBLE TRACK 300",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "30CM TACO",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-DT30H",
        ITEM: "REL LACI DOUBLE TRACK 300 HUBEN",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "30CM HUBEN",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-DT200",
        ITEM: "REL LACI DOUBLE TRACK 200",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "20CM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-1000B",
        ITEM: "REL LACI DOUBLE TRACK SKYRAIL 1000 BAI023",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "1 mtr kecil",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-1000S",
        ITEM: "REL LACI DOUBLE TRACK SKYRAIL 1000 SBI69",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "1 mtr besar",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TB1000",
        ITEM: "REL LACI DOUBLE TRACK BALENO 1000",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "1 mtr",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-RPDSK",
        ITEM: "REL POCKET DOOR SKYRAIL",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-AVHKS",
        ITEM: "AVENTOS HKS",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "AVN HK-S",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-AVHK",
        ITEM: "AVENTOS HK 29",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "AVN HK 29",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-AVHF",
        ITEM: "AVENTOS HF 22",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "AVN HF 22",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-AVHL",
        ITEM: "AVENTOS HL 27",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "AVN HL 27",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-AVHS",
        ITEM: "AVENTOS HS",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "AVN HS",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-HF2SE",
        ITEM: "AVENTOS HF 22 (SEBELAH)",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-HF5SE",
        ITEM: "AVENTOS HF 25 (SEBELAH)",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-AAF35",
        ITEM: "ARM AVENTOS F35",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TBS1",
        ITEM: "TANDEM BOX S1",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "TBX S1",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TBS2",
        ITEM: "TANDEM BOX S2",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "TBX S2",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TBS3",
        ITEM: "TANDEM BOX S3",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "TBX S3",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TBS4",
        ITEM: "TANDEM BOX S4",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "TBX S4",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TBI3",
        ITEM: "TANDEM BOX I3",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "TBX i3",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TBI4",
        ITEM: "TANDEM BOX I4",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "TBX i4",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TBI5",
        ITEM: "TANDEM BOX I5",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "TBX i5",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TBI6",
        ITEM: "TANDEM BOX I6",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "TBX i6",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-SDDRA",
        ITEM: "SERVO DRIVE DRAWER",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "SD for drawer",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-SDAVE",
        ITEM: "SERVO DRIVE AVENTOS",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "SD for aventos",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-RSKNO",
        ITEM: "REL SLIDING KNOCKER",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "P 15WD",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-RSTLH",
        ITEM: "REL SLIDING TOP LINE HETTICT",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "R8000043",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-RSF60",
        ITEM: "REL SLIDING FLAT 60 DS HAFELE",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "401.30.014",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-RSDD6",
        ITEM: "REL SLIDING DEKSON SR 8901 D6 3MTR",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "3 MTR",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-SCHRS",
        ITEM: "SOFT CLOSING HANGING ROLLER SERIES FULL SOFTCLOSE",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "V-802 WD",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-UB250",
        ITEM: "UPPER & BOTTOM TRACK ALUMINIUM 2500MM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "TV-2500",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-WMBSN",
        ITEM: "WALL MOUNTING BRACKET + SCREW & NUT",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "BRC-040",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-R688B",
        ITEM: "REL 688 DOF B",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "688",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-R380S",
        ITEM: "REL 380 SILVER",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "380",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-PAITA",
        ITEM: "PLINT ADJUSTER ITALIANA",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "D Diam 30 mm H25mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-ADATJ",
        ITEM: "ADJUSTER ATACAMA J",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-ABBHI",
        ITEM: "ADJUSTER BESI BULAT HITAM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "30 mm x M8",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-ABFLS",
        ITEM: "ADJUSTABLE FURNITURE LEG ( STAINLES)",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "100mm",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TOBLU",
        ITEM: "TIP ON BLUM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "956A1307S",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TOBSS",
        ITEM: "TIP ON BLUM SET SHORT",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TOSAY",
        ITEM: "TIP ON SAYAP ABU PANJANG",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TOSAP",
        ITEM: "TIP ON SAYAP ABU PENDEK",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-MTO2W",
        ITEM: "MAGNET TIP ON 2 WAY",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-MICAT",
        ITEM: "MINI CATH (U/ ENGSEL TENDANG)",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-SCAEN",
        ITEM: "SLOWMOTION CAPUNG ENGSEL",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-BC170",
        ITEM: "BLUMOTION CLIP ON 170 DEGREE",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "973A6000 NI",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-DMGSM",
        ITEM: "DOOR MOVE GREY SLOW MOVE",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-PP009",
        ITEM: "TARIKAN PP 009 S DEKSON",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "SUS 304",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TRSSG",
        ITEM: "TRAY RAK SEKAT SENDOK GARPU",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-TMB21",
        ITEM: "RAK BOTOL TARIK (SLIM) TWIN TMB 21555",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "TMB 21555",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-VITSC",
        ITEM: "RAK PERALATAN DAN SABUN CUCI VITCO SC 29061",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "VITCO SC 29061",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-RVS2S",
        ITEM: "RAK VITCO SC 27316 SM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "SC 27316 SM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-DCHOD",
        ITEM: "DOOR CLOSER HO DEKSON",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "302 HO",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-DC925",
        ITEM: "DOOR CLOSER PALOMA 925 SLIDING ARM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "925",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-DC411",
        ITEM: "DOOR CLOSER PALOMA 925 SLIDING ARM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "925 (DCP411)",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-DC883",
        ITEM: "DOOR CLOSER DEKSON DCL C883 NA",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "DCL C883 NA",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-MLRAF",
        ITEM: "MORTISE LOCK RAFES",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "SUS 304",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-DB010",
        ITEM: "DRAWER BASKET ORI PTJ 010 D",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-RK203",
        ITEM: "RING KUNCI KOTAK PALOMA ECP 203",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "BLACK MATTE",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-RK363",
        ITEM: "RING KUNCI KOTAK PALOMA ECP 363",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "BLACK MATTE",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-RB353",
        ITEM: "RING KUNCI BULAT PALOMA ECP 353",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "BLACK MATTE",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-RBSIL",
        ITEM: "RING KUNCI BULAT PALOMA SILVER",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "SILVER",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-RKCD8",
        ITEM: "RING KUNCI SILINDER DEKSON 84030 MATT BLACK",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "819ab17c74f84d878f5de30ca88c0d0d",
        REMARKS: "MATT BLACK",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-RK855",
        ITEM: "RING KUNCI SILINDER DEKSON 855 STAINLESS",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "STAINLESS SILVER",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-B8485",
        ITEM: "BODY DEKKSON 8485 STAINLESS STEEL 304",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-84030",
        ITEM: "BODY KUNCI DEKSON DL 84030 MATT BLACK",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "DL 84030 MATT BLACK",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-D8585",
        ITEM: "BODY KUNCI DEKSON DL 8585 MATT BLACK (SWING)",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "DL 8585 MATT BLACK",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-D8685",
        ITEM: "BODY KUNCI DEKSON 8685 ROLLER (PELOR)",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "DL 8685 SILVER",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-BKS85",
        ITEM: "BODY KUNCI SLIDING SLD DL 85100 SSS",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "DL 85100",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-HMDBL",
        ITEM: "HAFELE MORTISE DEADBOLT LOCK",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-SID60",
        ITEM: "SILINDER DEKKSON DL 60MM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-SKDTK",
        ITEM: "SILINDER KUNCI DEKSON DL 60MM MATT BLACK TANPA ANAK KUNCI",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "DL 60MM MATT BLACK TANPA ANAK KUNCI",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-SKD4S",
        ITEM: "SILINDER KUNCI DEKSON DL 40MM SILVER",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "DL 40MM SILVER",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-SKD60",
        ITEM: "SILINDER KUNCI DEKSON DL 60MM MATT BLACK",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "TC 60MM MATT BLACK",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-SK6TK",
        ITEM: "SILINDER KUNCI DEKSON DL 60MM MATT BLACK TANPA KNOB",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "DC 60MM MATT BLACK",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-SKD70",
        ITEM: "SILINDER KUNCI DEKSON DL 70 MM MATT BLACK",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "DL 70 MM MATT BLACK",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-SKD7S",
        ITEM: "SILINDER KUNCI DEKSON DC DL 70MM SILVER",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "DL 70MM SILVER",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-PKLTA",
        ITEM: "PLAT KUNCI L TAJAM",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-KH138",
        ITEM: "KUNCI HUBEN 138",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "22 MM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-SLGOL",
        ITEM: "SNAP LOCK GOLD",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "GOLD",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-SLSIB",
        ITEM: "SNAP LOCK SILVER BESAR",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "SILVER BESAR",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-OVGRS",
        ITEM: "OVERPAL GRENDEL S",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "S",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-OVGRM",
        ITEM: "OVERPAL GRENDEL M",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "M",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-FB223",
        ITEM: "FLUSH BOLT PALOMA FBP 223 MATTE BLACK",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "0af0a1c73eee418396d346068fa6f466",
        REMARKS: "8\" + 18\"",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "HDW-FIT-LTTM1",
        ITEM: "LIFT TOP TABLE MECHANISM 01-17A",
        CATEGORY_ID: "e362093c0a0847e6b3832202c9d9d0d3",
        CATEGORY_SUB_ID: "8d37f954c5d84527aa0a0ee015654b4e",
        UNIT_ID: "f82f4004e223497a915848c89d8a3d76",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-PLU-STKRA",
        ITEM: "STOP KRAN",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "283ca01f016140a2bf093e6e9c33a83a",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-PLU-SFL30",
        ITEM: "SELANG FLEXIBLE 30CM",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "283ca01f016140a2bf093e6e9c33a83a",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-PLU-SFL60",
        ITEM: "SELANG FLEXIBLE 60CM",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "283ca01f016140a2bf093e6e9c33a83a",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "60CM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-PLU-SPF15",
        ITEM: "SELANG PEMBUANGAN FLEXIBLE 1,5 MTR",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "283ca01f016140a2bf093e6e9c33a83a",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-PLU-SETAP",
        ITEM: "SEAL TAPE ONDO",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "283ca01f016140a2bf093e6e9c33a83a",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-PLU-STDCO",
        ITEM: "SEAL TAPE DCOTA",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "283ca01f016140a2bf093e6e9c33a83a",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-PLU-PP112",
        ITEM: "PIPA PVC 1 1/2 INCHI",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "283ca01f016140a2bf093e6e9c33a83a",
        UNIT_ID: "bb3b9eddf1304ecf9bea9c2696f2995f",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-PLU-KN112",
        ITEM: "KNEE 2 INCHI",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "283ca01f016140a2bf093e6e9c33a83a",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-PLU-KNE12",
        ITEM: "KNEE 1/2 INCH",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "283ca01f016140a2bf093e6e9c33a83a",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "1/2 INCH",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-PLU-DNA12",
        ITEM: "DOUBLE NAPLE 1/2 INCH",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "283ca01f016140a2bf093e6e9c33a83a",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "MEP-PLU-SDD12",
        ITEM: "DRAT DALAM SDD 1/2 INCH RUCIKA",
        CATEGORY_ID: "c0803aaff18047048807f52d2c8466c0",
        CATEGORY_SUB_ID: "283ca01f016140a2bf093e6e9c33a83a",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PUHWA",
        ITEM: "PU HARDENER WARNA",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "EMC-47S",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PUCSE",
        ITEM: "PU CLEAR SEMIGLOSS",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "EM-2282/50",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PUH2K",
        ITEM: "PU HARDENER 2K",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "EMC-309",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-WBI20",
        ITEM: "WB IDROFLOOR 20",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "OWE 20",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PAWG5",
        ITEM: "PU ACRYLIC WHITE G5",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "RL8-AG5W",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PHAAC",
        ITEM: "PU HARDENER ACRYLIC",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "EMC 08",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PUISO",
        ITEM: "PU ISOLATOR",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "EM-847",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PUHISO",
        ITEM: "PU HARDENER ISOLATOR",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "EMC-43S",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PUSS2",
        ITEM: "PU SANDING SEALER 2K",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "EM-3730",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PUH99",
        ITEM: "PU HARDENER 2K EMC-99",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "EMC-99",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PUG20",
        ITEM: "PU PARQUET G20",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "EM-3822/20",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PUHPA",
        ITEM: "PU HARDENER PARQUET",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "EMC-13",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PUTHI",
        ITEM: "PU THINNER MEDIUM",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "EM-754",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PLMSA",
        ITEM: "PU LIGHT MOCA SATIN",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "NCSS-2502Y",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-CSPET",
        ITEM: "CLEAR SATIN PETALAC",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-SWPET",
        ITEM: "SPECIAL WHITE PETALAC",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-MTSPE",
        ITEM: "MIX TAM SILVER PETALAC",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-CHAPE",
        ITEM: "CHARCOAL PETALAC",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-SRFPW",
        ITEM: "SURFACER FD BASE WHITE PETALAC",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-FIN-SRHRD",
        ITEM: "HARDENER SURFACER PETALAC",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "0,5 LITER",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-FIN-TPUPE",
        ITEM: "THINNER PU PETALAC",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-FIN-TPPG5",
        ITEM: "THINNER PU PETALAC GLN 5 LTR",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "5 LTR",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-MMX01",
        ITEM: "METALIC MX 01 BASE 0,8 LTR PETALAC",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "0,8 LTR",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-HM200",
        ITEM: "HARDENER METALIC 200 CC PETALAC",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "200 CC",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-CCCGL",
        ITEM: "CRYSTAL COAT CLEAR GLOSS",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "3fbb2b812bfc44099e925ac0ea69daa4",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-CCOTH",
        ITEM: "CRYSTAL COAT THINNER",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-97810",
        ITEM: "DUCO WHITE P781050",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "BU YOVI ",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PHR78",
        ITEM: "HARDENER PR 78",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "BU YOVI ",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PM1105",
        ITEM: "DUCO BLACK FENIX PM 11050",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "BU YOVI ",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PMR11",
        ITEM: "HARDENER PMR 11",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "BU YOVI ",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-TZ1305",
        ITEM: "TZ 1305 CLEAR DOFF",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-TH790",
        ITEM: "TH 790 HARDENER",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-TH79L",
        ITEM: "TH 790 HARDENER LTR",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-TH79C",
        ITEM: "TH 790 HARDENER BTL @200CC",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a2f53a1a02a8476b8afcdcafc19548bc",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-TH132",
        ITEM: "TZ 1325 CLEAR SATIN",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-TU55",
        ITEM: "TU 55 CLEAR BASE COAT",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-TV901",
        ITEM: "THINNER V901 TOP COAT",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-TV900",
        ITEM: "THINNER V900 BASE COAT",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-TV500",
        ITEM: "THINNER V500",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "FMA-FIN-TV600",
        ITEM: "THINNER V600",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PU910",
        ITEM: "PUSS 910 SANDING",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "FMA-FIN-P9C08",
        ITEM: "PUL 910 CLEAR 08 SET",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "3fbb2b812bfc44099e925ac0ea69daa4",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PUH20",
        ITEM: "PUH 20 LY FD HARDENER SANDING",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PUP52",
        ITEM: "PUP 52103 BASE A PRIMER",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PUH11",
        ITEM: "PUH 11 FD HARDENER PRIMER",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PUS51",
        ITEM: "PUS 51107 SEALER",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-S5120",
        ITEM: "PUS 51107 SEALER 20 LTR",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PUH01",
        ITEM: "PUH 101 FD XLS HARDENER SEALER",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-HS015",
        ITEM: "PUH 101 FD XLS HARDENER SEALER 5 LTR",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-FDTHI",
        ITEM: "THPU 71 FD THINNER",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "FMA-FIN-SDTHI",
        ITEM: "THPU 73 SD THINNER",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PUL91",
        ITEM: "PUL 91 CLEAR DOFF",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PUS91",
        ITEM: "PUSS 91 SANDING SEALER",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "3fbb2b812bfc44099e925ac0ea69daa4",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-U60CD",
        ITEM: "ULTRAN USE 60 CLEAR DOFF",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "3fbb2b812bfc44099e925ac0ea69daa4",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-U60CG",
        ITEM: "ULTRAN USE 60 CLEAR GLOSS",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "3fbb2b812bfc44099e925ac0ea69daa4",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-SS700",
        ITEM: "STAINLESS ROSE GOLD STAIN SS 700 0,2LTR",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-SGS02",
        ITEM: "STAINLESS GOLD STAIN SS 700 0,2LTR",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-LNB18",
        ITEM: "LNB 18 CATALYST AT 50% NON YELLOWING",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "LNB 18",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-NB182",
        ITEM: "LNB 18 CATALYST AT 50% NON YELLOWING (12,5 LTR)",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "LNB 18",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-LZC31",
        ITEM: "LZC 31 THINNER TOP COAT",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "LZC 31",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-LZ31G",
        ITEM: "LZC 31 THINNER TOP COAT GALON",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "LZC 31",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-LKR20",
        ITEM: "LKR 20883 RETRO WHITE",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "LKR 20883",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-LKR22",
        ITEM: "LKR 22070 WHITE CREAM",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "LKR 22070",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-LKR21",
        ITEM: "LKR 21600 BLACK DEATH MATT",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "LKR 21600",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-LKR18",
        ITEM: "LKR 18680 WHITE PANEL SATIN",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "LKR 18680",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-LKR23",
        ITEM: "LKR 23092 STEEL GREY KEY",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "LKR 23092",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-LQ836",
        ITEM: "LQA 836 PU INSULATOR",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "LQA 836",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-LN837",
        ITEM: "LNB 837 CATALYST PU AT 100%",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "LNB 837",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-LZC11",
        ITEM: "LZC 11 PU THINNER FAST DRY",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "LZC 11",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-LZ11G",
        ITEM: "LZC 11 PU THINNER FAST DRY GALON",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "LZC 11",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-LLA20",
        ITEM: "LLA 6020 PU POLISH ACRYLIC",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "LLA 6020",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-LNB10",
        ITEM: "LNB 110 CATALYST PU AT 100% NON YELLOWING",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "LNB 110",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-LZC89",
        ITEM: "LZC 9889 PU THINNER HIGH GLOSS",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "LZC 9889",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-P500A",
        ITEM: "PANNA 500 ABRALUX",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "PANNA 500",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-OMPOL",
        ITEM: "OMEGA POLISH",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-LBR16",
        ITEM: "LBR 16 PU WHITE PRIMER",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "LBR 16",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-LNB16",
        ITEM: "LNB 16 CATALYST PU AT 40%",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "LNB 16",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-LBA35",
        ITEM: "LBA 35 PU HS CLEAR SEALER",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "LBA 35",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-L3525",
        ITEM: "LBA 35 PU HS CLEAR SEALER (25 LTR)",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "LBA 35",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-LNB77",
        ITEM: "LNB 77 CATALYST PU AT 50%",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "LNB 77",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-L7712",
        ITEM: "LNB 77 CATALYST PU AT 50% (12,5 LTR)",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "LNB 77",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-LGA22",
        ITEM: "LGA 22 PU CLEAR MATT OP 20",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "LGA 22",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-C23MI",
        ITEM: "CIT 2316 MINT",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "CIT 2316",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-C03TI",
        ITEM: "CIT 2303 TIMBERLINE",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "CIT 2303",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-C25SB",
        ITEM: "CIT 1025 SALAK BROWN",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "CIT 1025",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-C14TO",
        ITEM: "CIT 2314 TORTORA",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "CIT 2314",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-THIND",
        ITEM: "THINNER NCHG 051",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "FMA-FIN-CWAGE",
        ITEM: "CASCOW WHITE AGENT",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PCBRO",
        ITEM: "PIGMEN COFFEE BROWN",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PPUSW",
        ITEM: "PIGMEN PUTIH SW",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PGYEL",
        ITEM: "PIGMEN GOLDEN YELLOW",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-PBLCK",
        ITEM: "PIGMEN BLACK",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-CSWNI",
        ITEM: "CAT SUPER WHITE NIPPE",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-CSWDN",
        ITEM: "CAT SUPER WHITE DOFF NIPPE",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-DGNCW",
        ITEM: "DANAGLOSS NC WHITE",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-WF115",
        ITEM: "DEMPUL IMPRA WF115 JATI",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-FIN-5F115",
        ITEM: "DEMPUL IMPRA WF115 JATI ISI 5KG",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "2492cc7081994f52a043f3e3144aaad1",
        REMARKS: "GALON ISI 5KG",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-SH113",
        ITEM: "DEMPUL IMPRA SH113 SUNGKAI",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-FIN-S113T",
        ITEM: "DEMPUL IMPRA SH113 TEAK",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-WP117",
        ITEM: "DEMPUL IMPRA WP117 WHITE",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-FIN-162SB",
        ITEM: "WOOD STAIN IMPRA 162B SALAK BROWN",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-FIN-162WB",
        ITEM: "WOOD STAIN IMPRA 162B WALNUT BROWN",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-FIN-162CB",
        ITEM: "WOOD STAIN IMPRA 162B COCOA BROWN",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-FIN-162DB",
        ITEM: "WOOD STAIN IMPRA 162B DARK BROWN",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-162DM",
        ITEM: "WOOD STAIN IMPRA 162B DARK MAHONY",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-162BL",
        ITEM: "WOOD STAIN IMPRA 162B BLACK",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-P1CWH",
        ITEM: "STAIN PST 12100 C10 WHITE",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-SKTBF",
        ITEM: "SENGKOTE BLACK DOFF",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-SB406",
        ITEM: "SENGKOTE BLACK 9406",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-TC6SM",
        ITEM: "TOP COLOR 6621 SILVER METALLIC",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "a4c2ebd7e7fa4a19a9779fa182961cff",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-DSPOL",
        ITEM: "DEMPUL SANPOLAC",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "",
        MIN_STOCK: "4"
    },
    {
        MATERIAL_CODE: "FMA-FIN-DSG4K",
        ITEM: "DEMPUL SANPOLAC GALON (4KG)",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "2492cc7081994f52a043f3e3144aaad1",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-FIN-TALDU",
        ITEM: "TALEK DUCO",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-FIN-FBB20",
        ITEM: "FINISHING BIOPOLISH BEESWAX 200 GRAM",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "200 GRAM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-VPR25",
        ITEM: "VIP PAINT REMOVER 250 GRAM",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "250 GRAM",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-RCOWH",
        ITEM: "RUBBING COMPOUND WHITE",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-SY500",
        ITEM: "SANPOLY 500ML",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "500ML",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-BO100",
        ITEM: "BRASSO 100ML",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "100ML",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-3PW73",
        ITEM: "3M PREMIUM WAX 7006 350ML",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "350ML",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-FIN-KEPOL",
        ITEM: "KERTAS POLOS",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "83a59bb8e70d4b159a04f1247dfca6da",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AT100",
        ITEM: "AMPLAS TAIYO 100",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "KSCW-SS 100",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AT120",
        ITEM: "AMPLAS TAIYO 120",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "KSCW-SS 120",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AT180",
        ITEM: "AMPLAS TAIYO 180",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "KSCW-SS 180",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AT220",
        ITEM: "AMPLAS TAIYO 220",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "KSCW-SS 220",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AT240",
        ITEM: "AMPLAS TAIYO 240",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "KSCW-SS 240",
        MIN_STOCK: "2"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AT360",
        ITEM: "AMPLAS TAIYO 360",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "KSCW-SS 360",
        MIN_STOCK: "2"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AT400",
        ITEM: "AMPLAS TAIYO 400",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "KSCW-SS 400",
        MIN_STOCK: "2"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AT600",
        ITEM: "AMPLAS TAIYO 600",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "KSCW-SS 600",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AT800",
        ITEM: "AMPLAS TAIYO 800",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "KSCW-SS 800",
        MIN_STOCK: "2"
    },
    {
        MATERIAL_CODE: "FMA-ABR-TB800",
        ITEM: "AMPLAS TAIYO BANGUNAN 800",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AT1000",
        ITEM: "AMPLAS TAIYO 1000",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "KSCW-SS 1000",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AT1500",
        ITEM: "AMPLAS TAIYO 1500",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "KSCW-SS 1500",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AT2000",
        ITEM: "AMPLAS TAIYO 2000",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "KSCW-SS 2000",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-ABR-S2000",
        ITEM: "AMPLAS SIKENS 2000",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "P2000",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AMP60",
        ITEM: "AMPLAS METERAN P60",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "RKJFO 60",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AMP80",
        ITEM: "AMPLAS METERAN P80",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "RKJFO 80",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AMP100",
        ITEM: "AMPLAS METERAN P100",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "RKJFO 100",
        MIN_STOCK: "10"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AMP120",
        ITEM: "AMPLAS METERAN P120",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "RKJFO 120",
        MIN_STOCK: "10"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AMP180",
        ITEM: "AMPLAS METERAN P180",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "RKJFO 180",
        MIN_STOCK: "10"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AMP240",
        ITEM: "AMPLAS METERAN P240",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "RKJFO 240",
        MIN_STOCK: "10"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AMP400",
        ITEM: "AMPLAS METERAN P400",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "RKJFO 400",
        MIN_STOCK: "10"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AN400",
        ITEM: "AMPLAS DRY SANDING NORTON 400",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "",
        MIN_STOCK: "10"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AE400",
        ITEM: "AMPLAS DRY SANDING EKA SILVER 400",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "",
        MIN_STOCK: "10"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AE150",
        ITEM: "AMPLAS DRY SANDING EKA SILVER 150",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AE240",
        ITEM: "AMPLAS DRY SANDING EKA SILVER 240",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AB120",
        ITEM: "AMPLAS BEAR P120",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AA80",
        ITEM: "AMPLAS SOLIGEN AA80",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-ABR-D1200",
        ITEM: "SUPER ASSILEX ORANGE DISK K 1200",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "ORANGE",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "FMA-ABR-D2000",
        ITEM: "SUPER BUFLEX GREEN DISK K 2000",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "GREEN",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "FMA-ABR-D3000",
        ITEM: "SUPER BUFLEX BLACK DISK K 3000",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "BLACK",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AS600",
        ITEM: "SUPER ASSILEX SKY K 600",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "SKY",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AL800",
        ITEM: "SUPER ASSILEX LEMON K 800",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "LEMON",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "FMA-ABR-A1200",
        ITEM: "SUPER ASSILEX ORANGE K 1200",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "ORANGE",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "FMA-ABR-B2000",
        ITEM: "SUPER BUFLEX GREEN K 2000",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "GREEN",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "FMA-ABR-B3000",
        ITEM: "SUPER BUFLEX BLACK K 3000",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "BLACK",
        MIN_STOCK: "5"
    },
    {
        MATERIAL_CODE: "FMA-ABR-SSNOR",
        ITEM: "SANDING SPONGE NORTON",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-ABR-71000",
        ITEM: "AMPLAS DISK 7 INCH P1000",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-ABR-7P600",
        ITEM: "AMPLAS DISK 7 INCH P600",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-ABR-7P800",
        ITEM: "AMPLAS DISK 7 INCH P800",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-ABR-7P400",
        ITEM: "AMPLAS DISK 7 INCH P400",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-ABR-B1000",
        ITEM: "AMPLAS BELT P1000",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-ABR-BP800",
        ITEM: "AMPLAS BELT P800",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-ABR-BP400",
        ITEM: "AMPLAS BELT P400",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "942 JFF 5",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AG100",
        ITEM: "AMPLAS GOLD P100",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AG150",
        ITEM: "AMPLAS GOLD P150",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AG180",
        ITEM: "AMPLAS GOLD P180",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-ABR-AG240",
        ITEM: "AMPLAS GOLD P240",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "FMA-ABR-BS240",
        ITEM: "BELT SANDER P240",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-ABR-FW212",
        ITEM: "AMPLAS FLYING WHEEL 2 1/2",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-ABR-NWHPG",
        ITEM: "NON WOVEN HAND PADS GREEN",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "FMA-ABR-SCBMA",
        ITEM: "SCOTCH BRITE MAROON",
        CATEGORY_ID: "c5b35d17ea51429da3dff087c4dba746",
        CATEGORY_SUB_ID: "b2d47e8812fd4e61a0d299d0084f2ec7",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "OTH-OUT-KBCOK",
        ITEM: "KAIN BELUDRU COKLAT",
        CATEGORY_ID: "43fc7fb3ea9b43c1a406314e0e24d533",
        CATEGORY_SUB_ID: "568639288b6a47c8a0b0bbbbee60a256",
        UNIT_ID: "f82f4004e223497a915848c89d8a3d76",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "OTH-OUT-DEMGY",
        ITEM: "DEMPUL GYPSUM",
        CATEGORY_ID: "43fc7fb3ea9b43c1a406314e0e24d533",
        CATEGORY_SUB_ID: "568639288b6a47c8a0b0bbbbee60a256",
        UNIT_ID: "d29574ad0a7949908126e884328a3a5e",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "OTH-OUT-DGYKG",
        ITEM: "DEMPUL GYPSUM KG",
        CATEGORY_ID: "43fc7fb3ea9b43c1a406314e0e24d533",
        CATEGORY_SUB_ID: "568639288b6a47c8a0b0bbbbee60a256",
        UNIT_ID: "795279c4c5b94bf9bd0fc69cfff7f49b",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "OTH-OUT-KASGY",
        ITEM: "KASA GYPSUM",
        CATEGORY_ID: "43fc7fb3ea9b43c1a406314e0e24d533",
        CATEGORY_SUB_ID: "568639288b6a47c8a0b0bbbbee60a256",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "OTH-OUT-GYPSU",
        ITEM: "GYPSUM",
        CATEGORY_ID: "43fc7fb3ea9b43c1a406314e0e24d533",
        CATEGORY_SUB_ID: "568639288b6a47c8a0b0bbbbee60a256",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "OTH-OUT-BACAT",
        ITEM: "BAKI CAT",
        CATEGORY_ID: "43fc7fb3ea9b43c1a406314e0e24d533",
        CATEGORY_SUB_ID: "568639288b6a47c8a0b0bbbbee60a256",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "OTH-OUT-ROCAT",
        ITEM: "ROLL CAT",
        CATEGORY_ID: "43fc7fb3ea9b43c1a406314e0e24d533",
        CATEGORY_SUB_ID: "568639288b6a47c8a0b0bbbbee60a256",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "OTH-OUT-CTK38",
        ITEM: "CAT TEMBOK KEMTONE BIRU NBD 3,8LTR",
        CATEGORY_ID: "43fc7fb3ea9b43c1a406314e0e24d533",
        CATEGORY_SUB_ID: "568639288b6a47c8a0b0bbbbee60a256",
        UNIT_ID: "2492cc7081994f52a043f3e3144aaad1",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "OTH-OUT-AS6MM",
        ITEM: "ACRILIC SUSU 6 MM",
        CATEGORY_ID: "43fc7fb3ea9b43c1a406314e0e24d533",
        CATEGORY_SUB_ID: "568639288b6a47c8a0b0bbbbee60a256",
        UNIT_ID: "ef26028c67a14f3d87bb4fe8ee7fd0fa",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PAM-ADH-LKDAI",
        ITEM: "LAKBAN KERTAS DAIMARU",
        CATEGORY_ID: "4e46802799344297b4f072d6aafbef33",
        CATEGORY_SUB_ID: "31f999110c374e65978d8b872c0e9f4e",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "24 mm x 21 mtr",
        MIN_STOCK: "10"
    },
    {
        MATERIAL_CODE: "PAM-ADH-WRA10",
        ITEM: "WRAPPING 10 CM x 200 MTR",
        CATEGORY_ID: "4e46802799344297b4f072d6aafbef33",
        CATEGORY_SUB_ID: "d174bef69fee4e9dbd41150cca6c9d58",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "10 cm x 200 mtr",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "PAM-ADH-WRA30",
        ITEM: "WRAPPING 30 CM",
        CATEGORY_ID: "4e46802799344297b4f072d6aafbef33",
        CATEGORY_SUB_ID: "d174bef69fee4e9dbd41150cca6c9d58",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "30 cm x 200 mtr",
        MIN_STOCK: "2"
    },
    {
        MATERIAL_CODE: "PAM-ADH-WRA50",
        ITEM: "WRAPPING 50 CM",
        CATEGORY_ID: "4e46802799344297b4f072d6aafbef33",
        CATEGORY_SUB_ID: "d174bef69fee4e9dbd41150cca6c9d58",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "50 cm x 250 mtr",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "PAM-ADH-W5X15",
        ITEM: "WRAPPING 50 CM x 150 MTR",
        CATEGORY_ID: "4e46802799344297b4f072d6aafbef33",
        CATEGORY_SUB_ID: "d174bef69fee4e9dbd41150cca6c9d58",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "50 cm x 150 mtr",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "PAM-ADH-PO3MM",
        ITEM: "POLYFOAM 3 MM",
        CATEGORY_ID: "4e46802799344297b4f072d6aafbef33",
        CATEGORY_SUB_ID: "d174bef69fee4e9dbd41150cca6c9d58",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "",
        MIN_STOCK: "2"
    },
    {
        MATERIAL_CODE: "PAM-ADH-SINFA",
        ITEM: "SINGLE FACE",
        CATEGORY_ID: "4e46802799344297b4f072d6aafbef33",
        CATEGORY_SUB_ID: "d174bef69fee4e9dbd41150cca6c9d58",
        UNIT_ID: "edad6aae2a044d7c987ee4b15eb2a795",
        REMARKS: "160CM 24,5 kg",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "PAM-ADH-PLCOR",
        ITEM: "PLASTIK COR",
        CATEGORY_ID: "4e46802799344297b4f072d6aafbef33",
        CATEGORY_SUB_ID: "d174bef69fee4e9dbd41150cca6c9d58",
        UNIT_ID: "ae4df8f977fe405794f815f8a3c52a09",
        REMARKS: "",
        MIN_STOCK: "0"
    },
    {
        MATERIAL_CODE: "CLT-CLE-SAPU",
        ITEM: "SAPU",
        CATEGORY_ID: "87dfbf5e15804fd1acdd1c83d54fc40f",
        CATEGORY_SUB_ID: "a91511115a0749fead2b0be6b3de3aee",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "CLT-CLE-PENKI",
        ITEM: "PENGKI",
        CATEGORY_ID: "87dfbf5e15804fd1acdd1c83d54fc40f",
        CATEGORY_SUB_ID: "a91511115a0749fead2b0be6b3de3aee",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "CLT-CLE-LAMIC",
        ITEM: "LAP MICROFIBER",
        CATEGORY_ID: "87dfbf5e15804fd1acdd1c83d54fc40f",
        CATEGORY_SUB_ID: "a91511115a0749fead2b0be6b3de3aee",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "40x40 CM 320 GSM",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "CLT-CLE-CL425",
        ITEM: "CLING PEMBERSIH KACA SPRAY 425 ML",
        CATEGORY_ID: "87dfbf5e15804fd1acdd1c83d54fc40f",
        CATEGORY_SUB_ID: "a91511115a0749fead2b0be6b3de3aee",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "425ML",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "CLT-CLE-THC50",
        ITEM: "TACO HPL CLEANER 500 ML",
        CATEGORY_ID: "87dfbf5e15804fd1acdd1c83d54fc40f",
        CATEGORY_SUB_ID: "a91511115a0749fead2b0be6b3de3aee",
        UNIT_ID: "ae71e4c8c24646dfa10a428f2c53172f",
        REMARKS: "500ML",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "CLT-CLE-PPF45",
        ITEM: "PLEDGE PEMBERSIH FURNITURE SPRAY 450 ML",
        CATEGORY_ID: "87dfbf5e15804fd1acdd1c83d54fc40f",
        CATEGORY_SUB_ID: "a91511115a0749fead2b0be6b3de3aee",
        UNIT_ID: "95684dd61bea46f3bba200fff783a957",
        REMARKS: "450ML",
        MIN_STOCK: "1"
    },
    {
        MATERIAL_CODE: "CLT-CLE-ARS50",
        ITEM: "ANTI RAYAP TOP STAR SPRAY 500 ML",
        CATEGORY_ID: "87dfbf5e15804fd1acdd1c83d54fc40f",
        CATEGORY_SUB_ID: "a91511115a0749fead2b0be6b3de3aee",
        UNIT_ID: "ae71e4c8c24646dfa10a428f2c53172f",
        REMARKS: "500ML",
        MIN_STOCK: "0"
    }
]